import React from "react";
import "../screen/signup.css";

export default class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matric: false,
      inter: false,
      graduate: false,
      master: false,
    };
  }
  render() {
    const { value, onChangeValue, type, title, placeholder, maxLength, pattern, max, min } = this.props;
    return (
      <>
        <label className='lab'>{title}</label>
        <input className="inp" min={min} max={max} pattern={pattern} type={type} maxLength={maxLength} placeholder={placeholder} value={value} onChange={onChangeValue} />
      </>
    );
  }
}
